import React from "react";
import { SearchIcon } from "../assets/Icons";
import "../assets/css/search.scss";

const Search = ({ className, ...rest }) => {
  return (
    <>
      <div className="search-bar">
        <input type="text" className={`form-control ${className || ""}`} autoComplete="off" {...rest} />
        <span className="search-btn">
          <SearchIcon />
        </span>
      </div>
    </>
  );
};

export default Search;
